'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.syncData = exports.Helper = undefined;

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.promoPrice = promoPrice;
exports.promoData = promoData;
exports.partnerData = partnerData;
exports.getListActive = getListActive;
exports.parseParams = parseParams;
exports.parseQuery = parseQuery;

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _lodash = require('lodash');

var _numeral = require('numeral');

var _numeral2 = _interopRequireDefault(_numeral);

var _Constant = require('helpers/Constant');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fieldCoupon = ['name', 'typeVoucher', 'code', 'startDate', 'endDate', 'status', 'typePromotion', 'newPrice', 'percent', 'valueDiscount', 'packageService', 'userUsed'];
var Helper = exports.Helper = {
  webp: null,
  isSafari: function isSafari() {
    return (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)
    );
  },
  getScreen: function getScreen() {
    var pathname = location.pathname;
    // console.log('@getScreen', pathname, TRACKING_ROUTE[pathname]);
    if (pathname === '/') return _Constant.TRACKING_ROUTE[pathname];

    pathname = pathname.replace('/', '');
    var tracking = _Constant.TRACKING_ROUTE[pathname];
    console.log('replace pathname', pathname, tracking);
    return (0, _extends3.default)({}, tracking);
  },
  prints: function prints() {
    if (_config2.default.debugMode) {
      for (var i = 0, len = arguments.length; i < len; i++) {
        console.log(arguments[i]);
      }
    }
  },
  canUseWebp: function canUseWebp() {
    if ((typeof document === 'undefined' ? 'undefined' : (0, _typeof3.default)(document)) !== 'object') {
      this.webp = false;
      return false;
    }
    var canvas = document.createElement('canvas');
    if (!canvas.getContext || !canvas.getContext('2d')) {
      this.webp = false;
      return false;
    }
    this.webp = canvas.toDataURL('image/webp').indexOf('data:image/webp') === 0;
    return this.webp;
  },
  classNameWebp: function classNameWebp(className, webp) {
    if (this.webp !== null && this.webp || this.canUseWebp()) {
      return className + ' ' + webp;
    }
    return className;
  },
  convertTextSearch: function convertTextSearch(str) {
    var text = str;
    if (text) {
      text = text.trim();
      text = text.toLowerCase();
      text = text.replace(/\+/g, '-');
      text = text.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, 'a');
      text = text.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, 'e');
      text = text.replace(/ì|í|ị|ỉ|ĩ/g, 'i');
      text = text.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, 'o');
      text = text.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, 'u');
      text = text.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, 'y');
      text = text.replace(/đ/g, 'd');
      text = text.replace(/\ /g, '-');
      text = text.replace(/\|/g, '-');
      text = text.replace(/\./g, '-');
      text = text.replace(/\--/g, '-');
      text = text.replace(/\?/g, '-');
      text = text.replace(/\!/g, '-');
      text = text.replace(/\:/g, '-');
      text = text.replace(/\;/g, '-');
      text = text.replace(/\,/g, '-');
      text = text.replace(/\"/g, '-');
      // text = text.replace(/\'/g, "-");
      text = text.replace(/\[/g, '-');
      text = text.replace(/\]/g, '-');
      text = text.replace(/\)/g, '-');
      text = text.replace(/\(/g, '-');
      text = text.replace(/\\/g, '-');
      text = text.replace(/\//g, '-');
      text = text.replace(/\~/g, '-');
      text = text.replace(/\`/g, '-');
      text = text.replace(/\@/g, '-');
      text = text.replace(/\#/g, '-');
      text = text.replace(/\$/g, '-');
      text = text.replace(/\%/g, '-');
      text = text.replace(/\^/g, '-');
      text = text.replace(/\&/g, '-');
      text = text.replace(/\*/g, '-');
      text = text.replace(/\--/g, '-');
      text = text.replace(/\---/g, '-');
      text = text.replace(/^(-)+/, '');
      text = text.replace(/(-)+$/, '');
      text = text.replace(/([\uE000-\uF8FF]|\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDDFF])/g, '');
    }
    return text;
  },
  warn: function warn() {
    if (Helper.isDev()) {
      for (var i = 0, len = arguments.length; i < len; i++) {
        console.warn(arguments[i]);
      }
    }
  },
  rankNo: function rankNo(rank) {
    if (rank) {
      var _r = _Constant.RANK[rank];
      return _r && _r.no ? _r.no : -1;
    }
    return -1;
  },
  isDev: function isDev() {
    return _config2.default.debugMode;
  },
  getDistanceTop: function getDistanceTop(el) {
    if (!el) {
      return 0;
    }
    return el.getBoundingClientRect().top;
  },
  formatMoney: function formatMoney(cents, mu) {
    if (!cents) return cents;
    var unit = mu ? ' ' + mu : ' đ';
    return String(cents).replace(/(.)(?=(\d{3})+$)/g, '$1.') + unit;
  },

  newGuid: function newGuid() {
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
    }
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
  },
  generateWeek: function generateWeek(week) {
    var result = [].concat((0, _toConsumableArray3.default)(week));
    // Fill Head
    var first = new Date(week[0].date);
    var lenFirst = first.getDay() === 0 ? 7 : first.getDay();
    for (var i = 1; i < lenFirst; i++) {
      // Each loop: first will move on another day.
      var before = new Date(first.setDate(first.getDate() - 1));
      var item = {
        date: (0, _moment2.default)(before).format('YYYY-MM-DD'),
        type: '',
        empty: 0
      };
      result.unshift(item);
    }
    // Fill Tail
    // Calculator Step
    var last = new Date(week[week.length - 1].date);
    var lenLast = last.getDay() === 0 ? 0 : 8 - last.getDay();
    for (var _i = 1; _i < lenLast; _i++) {
      // Each loop: last will move on another day.
      var after = new Date(last.setDate(last.getDate() + 1));
      var _item2 = {
        date: (0, _moment2.default)(after).format('YYYY-MM-DD'),
        type: 'future',
        empty: 0
      };
      result.push(_item2);
    }
    // console.log('@this @generateWeek result:', result);
    return result;
  },
  slitWeek: function slitWeek(arr) {
    // Description: chia dữ liệu thành từng tuần mỗi week đều phải full ngày để render nên cần generate nếu tuần ko có đủ dữ liệu
    var weeks = {};
    var bookingTimes = {};
    var index = 0;
    weeks[index] = [];
    // const curr = new Date();
    for (var i = 0, len = arr.length; i < len; i++) {
      weeks[index].push(arr[i]);
      var date = new Date(arr[i].date);
      if (date.getDay() === 0) {
        if (weeks[index].length !== 7) {
          // TODO: Tuần đầu tiên
          weeks[index] = this.generateWeek(weeks[index]);
        }
        if (i !== len - 1) {
          // Ngắt tuần
          // Phần tử cuối cùng rơi vào chủ nhật thì ko cần ngắt tuần nữa.
          index++;
          weeks[index] = [];
        }
      }
      if (i === len - 1) {
        // Tuần cuối cùng, khi chưa đủ ngày tới chủ nhật.
        if (weeks[index].length !== 7) {
          // TODO: Tuần đầu tiên
          weeks[index] = this.generateWeek(weeks[index]);
        }
      }
      // else if (((i + 1) === len)) {
      //   // TODO: Tuần cuối cùng
      //   weeks[index] = this.generateWeek(weeks[index]);
      // }
      // BookingTime
      if (arr[i].empty > 0) {
        bookingTimes[(0, _moment2.default)(arr[i].date).format('YYYY-MM-DD')] = arr[i].bookingTimes;
      }
    }
    return { weeks: weeks, bookingTimes: bookingTimes };
  },
  toTime: function toTime(mins) {
    if (mins) {
      var m = parseInt(mins, 10);
      var hour = Math.floor(m / 60);
      var min = Math.floor(m % 60);
      return hour + ':' + (min === 0 ? '00' : min);
    }
    return '';
  },
  shortenDisplayPrice: function shortenDisplayPrice(price) {
    if (price / 1000000 >= 1) return price / 1000000 + 'tr';
    if (price / 1000 >= 1) return price / 1000 + 'k';
    return price;
  },
  toTimeBooking: function toTimeBooking(date, time) {
    if (date) {
      return (this.toTime(time) ? this.toTime(time) + ' -' : '') + ' ' + (0, _moment2.default)(date).format('DD-MM-YYYY');
    }
    return '';
  },
  indexOfServices: function indexOfServices(arr, item) {
    if (arr) {
      var index = (0, _lodash.findIndex)(arr, { service: item.service });
      return index;
    }
    return -1;
  },
  removeServices: function removeServices(arr, item) {
    var _arr = [].concat((0, _toConsumableArray3.default)(arr));
    if (_arr) {
      (0, _lodash.remove)(_arr, function (v) {
        return v.service === item.service;
      });
      return _arr;
    }
    // console.log(arr[0]);
    return [];
  },
  addServices: function addServices(arr, item) {
    var _arr = [].concat((0, _toConsumableArray3.default)(arr));
    if (_arr && item.service && item.number) {
      _arr.push(item);
    }
    return _arr;
  },
  removeOptions: function removeOptions(arr, item) {
    var _arr = [].concat((0, _toConsumableArray3.default)(arr));
    if (_arr) {
      (0, _lodash.remove)(_arr, function (v) {
        return v._id === item._id;
      });
      return _arr;
    }
    // console.log(arr[0]);
    return [];
  },
  addOptions: function addOptions(arr, item) {
    var _arr = [].concat((0, _toConsumableArray3.default)(arr));
    var exist = _arr.find(function (op) {
      return op._id === item._id;
    });
    if (_arr && item._id && !exist) {
      _arr.push(item);
    }
    return _arr;
  },
  updateServices: function updateServices(arr, item) {
    var _arr = [].concat((0, _toConsumableArray3.default)(arr));
    if (_arr) {
      var index = Helper.indexOfServices(_arr, item);
      if (index !== -1) {
        _arr[index].number = item.number;
      } else {
        _arr = Helper.addServices(_arr, item);
      }
      return _arr;
    }
    return [];
  },
  subObject: function subObject(main, arr) {
    var subObj = {};
    if (main && arr) {
      arr.map(function (v) {
        if (main.hasOwnProperty(v)) subObj[v] = main[v];
      });
    }
    return subObj;
  },
  distanceTwoDate: function distanceTwoDate(end, start) {
    if (end) {
      var two = (0, _moment2.default)(end);
      var one = (0, _moment2.default)();
      if (start) {
        one = (0, _moment2.default)(start);
      }
      var disTime = Math.abs(two.valueOf() - one.valueOf());
      var disDays = Math.ceil(disTime / (1000 * 60 * 60 * 24));
      return disDays;
    }
    return -1;
  },

  displayDate: function displayDate(strDate) {
    var strDateRe = '';
    var dateModified = new Date(strDate);
    strDateRe = (0, _moment2.default)(dateModified).format('DD/MM/YYYY');
    return strDateRe;
  },
  isPromoted: function isPromoted(coupon, bookingServices) {
    if (coupon.isUsed) return false;
    var serviceId = coupon.service._id;
    var services = bookingServices.filter(function (v) {
      return v.service === serviceId && v.number !== 0;
    });
    return services && services.length;
  },
  billData: function billData(bill) {
    var result = {};
    if (bill) {
      var billRender = bill.billRender,
          discountOnTotalBill = bill.discountOnTotalBill,
          total = bill.total,
          totalBeforeDiscountAll = bill.totalBeforeDiscountAll,
          totalCost = bill.totalCost;

      var services = [];
      billRender.map(function (v) {
        var item = {};
        item.name = v.serviceName + ' (x' + v.number + ')';
        item.price = Helper.formatMoney(v.totalCost);
        // TODO: detail của discount.
        var details = [];
        if (v.details && v.details.length) {
          v.details.map(function (k) {
            var itemTemp = (0, _extends3.default)({}, k);
            if (k.typeDiscount === 'code' && k.code) {
              itemTemp.name = 'M\xE3 gi\u1EA3m gi\xE1 ' + k.code + ' (x' + k.number + ')';
            } else if (k.typeDiscount === 'time') {
              itemTemp.name = 'Gi\u1EA3m gi\xE1 khung gi\u1EDD (x' + k.number + ')';
            }
            itemTemp.price = '- ' + Helper.formatMoney(itemTemp.totalDiscount);
            details.push(itemTemp);
          });
        }
        item.details = details;
        services.push(item);
      });
      result.services = services;
      // Khuyến mãi trên khung giờ
      result.discountAll = Helper.formatMoney(discountOnTotalBill);
      // Giá khách hàng phải trả
      result.total = Helper.formatMoney(total);
      // Giá trước khuyến mãi khung giờ
      result.totalBeforeDiscountAll = Helper.formatMoney(totalBeforeDiscountAll);
      // Giá gốc
      result.totalCost = Helper.formatMoney(totalCost);
    } else {
      console.warn('@billData: bill is undefined');
    }
    return result;
  },
  bookingRequestData: function bookingRequestData(bookingRequest) {
    try {
      if (bookingRequest) {
        var shop = bookingRequest.shop,
            status = bookingRequest.status,
            noteByUser = bookingRequest.noteByUser,
            slot = bookingRequest.slot,
            userInfo = bookingRequest.userInfo,
            bookingTime = bookingRequest.bookingTime,
            bookingServices = bookingRequest.bookingServices,
            atHome = bookingRequest.atHome,
            bookingAddress = bookingRequest.bookingAddress;

        console.log('shop: ', shop);
        var shopData = {
          name: shop.name,
          category: shop.category ? shop.category : 'Chăm Sóc Da, Massage',
          address: shop.displayAdress ? shop.displayAdress : shop.address,
          handle: shop.handle,
          image: shop.image,
          shopType: shop.shopType,
          averagePoint: shop.averagePoint,
          isParent: shop.id === shop.parent
        };
        var timeData = [Helper.toTimeBooking(bookingTime.bookingSchedule.date, bookingTime.time)];
        var slotData = [slot];
        var servicesData = [];
        bookingServices.map(function (bService) {
          if (bService.number > 0) {
            var serName = '';
            if (bService.serviceRewrite) {
              serName = bService.serviceRewrite.name + ' (x' + bService.number + ')';
            } else {
              serName = bService.service.name + ' (x' + bService.number + ')';
            }
            var ser = {
              text: serName,
              selectedOptions: bService.serviceOptions
            };
            servicesData.push(ser);
          }
        });
        var noteData = [noteByUser];
        var customerData = ['T\xEAn kh\xE1ch h\xE0ng: ' + userInfo.name, '\u0110i\u1EC7n tho\u1EA1i: ' + userInfo.phone];
        if (atHome && bookingAddress && bookingAddress.addressDisplay) {
          customerData.push('\u0110\u1ECBa ch\u1EC9: ' + bookingAddress.addressDisplay);
        }
        return {
          shop: shopData,
          time: timeData,
          slot: slotData,
          services: servicesData,
          note: noteData,
          customer: customerData,
          status: status,
          atHome: atHome,
          date: bookingTime.bookingSchedule.date,
          mins: bookingTime.time
        };
      }
      console.warn('@bookingRequestData: bookingRequest is undefined');
    } catch (e) {
      console.warn('error: ', e);
    }
  },
  bookingRequestsData: function bookingRequestsData(bookingRequests) {
    try {
      var result = [];
      if (bookingRequests) {
        var _loop = function _loop(i, len) {
          var bookingRequest = bookingRequests[i];
          var bookingRequestId = bookingRequest._id,
              slot = bookingRequest.slot,
              bookingServices = bookingRequest.bookingServices,
              bookingTime = bookingRequest.bookingTime,
              status = bookingRequest.status,
              shopParent = bookingRequest.shop;

          var serviceData = [];
          // services.map(v => serviceData.push(v.service.name));
          bookingServices.map(function (v) {
            if (v.serviceRewrite) {
              serviceData.push(v.serviceRewrite.name);
            } else if (v.service) {
              serviceData.push(v.service.name);
            }
          });
          var service = serviceData.length ? 'D\u1ECBch v\u1EE5: ' + serviceData.join(' ,') : '';
          var shop = Helper.subObject(shopParent, ['name', 'image']);
          var time = Helper.toTimeBooking(bookingTime.bookingSchedule.date, bookingTime.time);
          var slotTime = '\u0110\u1EB7t ' + slot + ' ch\u1ED7 \u2022 ' + time;
          result.push({
            bookingRequestId: bookingRequestId,
            shop: shop,
            slotTime: slotTime,
            slot: slot,
            time: time,
            service: service,
            status: status
          });
          // shop, slottime, slot, time, service, status
        };

        for (var i = 0, len = bookingRequests.length; i < len; i++) {
          _loop(i, len);
        }
        return result;
      }
      console.warn('@previewData: bookingRequest is undefined');
    } catch (e) {
      console.warn('error: ', e);
    }
  },
  campaignData: function campaignData(campaign) {
    if (campaign) {
      var packageService = campaign.packageServices[0];
      var item = {
        condition: campaign.condition,
        name: campaign.name,
        code: campaign.code,
        typeVoucher: campaign.typeVoucher,
        startDate: Helper.displayDate(campaign.startDate),
        endDate: Helper.displayDate(campaign.endDate)
      };
      var imageURL = campaign.imageURL || 'https://truetech.com.vn/ww/wp-content/uploads/2016/12/no-image-placeholder-big.jpg';
      item = (0, _extends3.default)({}, item, {
        imageURL: imageURL,
        shop: packageService.shop,
        service: packageService.service,
        discount: packageService.discountForBooking,
        isUsed: packageService.isUsed
      });
      return item;
    }
    return null;
  },
  makeCouponData: function makeCouponData(code, codeError) {
    var result = {
      type: 'default',
      name: 'Nhập mã giảm giá',
      leftIcon: '/booking/discount.png'
    };
    if (code) {
      if (codeError) {
        // Lỗi code
        result = {
          type: 'inactive',
          name: 'M\xE3 ' + code + ' kh\xF4ng kh\u1EA3 d\u1EE5ng.',
          leftIcon: '/booking/details.png'
        };
      } else {
        result = {
          type: 'active',
          name: code,
          leftIcon: '/booking/details.png'
        };
      }
    }
    return result;
  },

  // Support For Header Config
  getConfigHeader: function getConfigHeader(page) {
    if (page && _Constant.ROUTE_CONFIGS[page]) return _Constant.ROUTE_CONFIGS[page];
    return _Constant.ROUTE_CONFIGS.default;
  },
  isExpand: function isExpand(services, actives) {
    var result = false;
    if (services && actives) {
      services.map(function (service) {
        actives.map(function (active) {
          if ((service._id === active.service || service.service === active.service) && active.number > 0) {
            result = true;
          }
        });
      });
    }
    return result;
  },
  serviceIsExist: function serviceIsExist(serviceId, services) {
    if (serviceId && services && services.length) {
      var exist = services.filter(function (v) {
        return v._id === serviceId;
      });
      // v => v._id === serviceId || v.service === serviceId
      if (exist && exist.length === 0) {
        return false;
      }
    }
    return true;
  },

  // @parse data

  groupServicesToServices: function groupServicesToServices(groupServices) {
    var services = [];
    if (groupServices && groupServices.length) {
      groupServices.forEach(function (v) {
        if (v.services && v.services.length) {
          services = [].concat((0, _toConsumableArray3.default)(services), (0, _toConsumableArray3.default)(v.services));
        }
      });
    }
    return services;
  },
  groupServicesToHomeServices: function groupServicesToHomeServices(groupServices) {
    var services = [];
    if (groupServices && groupServices.length) {
      groupServices.forEach(function (v) {
        if (v.services && v.services.length) {
          v.services.forEach(function (ser) {
            ser.newPrice = ser.price;
            ser.oldPrice = ser.originalPrice;
            ser.image = ser.image || 'https://minio.lookme.vn/assets/hi%CC%80nh%20di%CC%A3ch%20vu%CC%A3_2-01.jpg';
          });
          services = [].concat((0, _toConsumableArray3.default)(services), (0, _toConsumableArray3.default)(v.services));
        }
      });
    }
    return services;
  },
  parsePackageServiceToCard: function parsePackageServiceToCard(packageService) {
    var card = {};
    if (packageService && packageService.campaign) {
      var campaign = packageService.campaign,
          shop = packageService.shop,
          serviceRewrite = packageService.serviceRewrite,
          displayValue = packageService.displayValue,
          image = packageService.image,
          pointReward = packageService.pointReward,
          handle = packageService.handle,
          numPacks = packageService.numPacks,
          star = packageService.star,
          notSupportOn = packageService.notSupportOn,
          _id = packageService._id;
      // const serviceRewrite = packageService.serviceRewrite || packageService.service; // Chổ này API load chưa ổn, lúc thì có serviceRewrite lúc thì không!!!

      var address = shop && shop.addressDisplay ? shop.addressDisplay : shop.address;
      if (numPacks > 1) {
        address = '\xC1p d\u1EE5ng t\u1EA1i ' + numPacks + ' chi nh\xE1nh';
      }
      card = {
        name: campaign.name,
        countDown: Helper.distanceTwoDate(campaign.limitDate),
        forRank: campaign.forRank ? campaign.forRank : '',
        shopName: shop.name,
        appLink: !!(serviceRewrite && serviceRewrite.appLink) ? serviceRewrite.appLink : '',
        address: address,
        oldPrice: serviceRewrite ? serviceRewrite.price : '',
        shop: shop,
        service: serviceRewrite,
        numPacks: numPacks,
        star: star,
        notSupportOn: notSupportOn,
        //
        image: image,
        newPrice: displayValue,
        exu: pointReward,
        allowExchange: true,
        handle: handle,
        packId: _id
      };
    }
    return card;
  },
  parseMyVoucherToCard: function parseMyVoucherToCard(item) {
    var _item$packageService = item.packageService,
        shop = _item$packageService.shop,
        service = _item$packageService.service,
        notSupportOn = _item$packageService.notSupportOn;

    var _item = {
      title: item.campaign.name,
      code: item.code,
      countDown: Helper.distanceTwoDate(item.campaign.limitDate),
      image: item.packageService.image,
      newPrice: item.packageService.displayValue,
      oldPrice: service.price,
      shopName: shop.name,
      isBooking: shop.isBooking,
      address: shop.addressDisplay ? shop.addressDisplay : shop.address,
      isUsed: item.isUsed,
      packId: item.packageService._id,
      shop: shop,
      service: service,
      notSupportOn: notSupportOn
    };
    return _item;
  },
  parseCouponToCard: function parseCouponToCard(coupon, shopId) {
    var card = {};
    if (coupon && coupon.campaign && coupon.code && coupon.packageService) {
      var _coupon$campaign = coupon.campaign,
          startDate = _coupon$campaign.startDate,
          endDate = _coupon$campaign.endDate,
          name = _coupon$campaign.name,
          limitDate = _coupon$campaign.limitDate,
          _coupon$packageServic = coupon.packageService,
          image = _coupon$packageServic.image,
          shop = _coupon$packageServic.shop,
          service = _coupon$packageServic.service,
          displayValue = _coupon$packageServic.displayValue,
          packId = _coupon$packageServic._id,
          code = coupon.code,
          isUsed = coupon.isUsed;

      var isValid = true;
      var expired = new Date() > (0, _moment2.default)(endDate, 'DD/MM/YYYY');
      if (isUsed || expired || shopId && shop._id !== shopId) {
        isValid = false;
      }
      card = {
        title: name,
        startDate: startDate,
        endDate: endDate,
        countDown: Helper.distanceTwoDate(limitDate),
        newPrice: displayValue,
        oldPrice: service.price,
        shopName: shop.name,
        isBooking: shop.isBooking,
        address: shop.addressDisplay ? shop.addressDisplay : shop.address,
        image: image || 'https://truetech.com.vn/ww/wp-content/uploads/2016/12/no-image-placeholder-big.jpg',
        isUsed: isUsed,
        packId: packId,
        isValid: isValid,
        code: code,
        shop: shop,
        service: service
      };
    }
    return card;
  },
  parseCampaignToCard: function parseCampaignToCard(campaign) {
    var result = [];
    if (campaign) {
      var _item = {
        name: campaign.name,
        countDown: Helper.distanceTwoDate(campaign.limitDate)
      };
      campaign.packageServices.map(function (packageService) {
        var shop = packageService.shop,
            service = packageService.service;

        _item = (0, _extends3.default)({}, _item, {
          image: packageService.image,
          newPrice: packageService.displayValue,
          oldPrice: service.price,
          shopName: shop.name,
          address: shop.addressDisplay ? shop.addressDisplay : shop.address,
          exu: packageService.pointReward,
          handle: packageService.handle,
          packId: packageService._id,
          expired: new Date() > (0, _moment2.default)(campaign.endDate),
          shop: shop,
          service: service
        });
        result.push(_item);
      });
    }
    return result;
  },
  parseBranchByPacks: function parseBranchByPacks(packs) {
    var branchs = [];
    if (packs && packs.length) {
      packs.forEach(function (pack) {
        var shop = (0, _extends3.default)({}, pack.shop, { pack: pack });
        branchs.push(shop);
      });
    }
    return branchs;
  },

  getStructureJSON: function getStructureJSON(shop) {
    if (shop) {
      var reviews = shop.reviews,
          handle = shop.handle,
          weekday = shop.weekday,
          openTime = shop.openTime,
          closeTime = shop.closeTime,
          mainCategory = shop.mainCategory;

      var link = _config2.default.siteUrl + '/' + handle;
      var _type = 'BeautySalon';
      if (mainCategory && mainCategory.link) {
        _type = _Constant.TYPE_LOCAL_BUSINESS[mainCategory.link] || 'BeautySalon';
      }
      var priceRange = shop.minPrice && shop.maxPrice ? (0, _numeral2.default)(shop.minPrice).format('0,0') + 'đ - ' + (0, _numeral2.default)(shop.maxPrice).format('0,0') + 'đ' : shop.priceRange;
      var dataJSON = {
        sameAs: link,
        image: shop.image,
        telephone: shop.phone,
        aggregateRating: {
          worstRating: '1',
          bestRating: '10',
          ratingCount: shop.totalReview,
          '@type': 'AggregateRating',
          ratingValue: shop.point
        },
        address: shop.addressDisplay ? shop.addressDisplay : shop.address,
        '@id': link,
        // servesCuisine: 'N/A',
        name: shop.name,
        priceRange: priceRange,
        '@context': 'http://schema.org',
        '@type': _type
      };
      // Review
      if (reviews && reviews.length) {
        var _reviews$ = reviews[0],
            comment = _reviews$.comment,
            user = _reviews$.user,
            createdAt = _reviews$.createdAt,
            rating = _reviews$.rating;

        var review = {
          inLanguage: 'vi',
          description: comment,
          datePublished: createdAt || 'None',
          reviewRating: {
            ratingValue: rating,
            bestRating: '10',
            '@type': 'Rating',
            worstRating: '1'
          },
          '@type': 'Review',
          author: {
            '@type': 'Person',
            name: user && user.profile && user.profile.name ? user.profile.name : 'Vô Danh'
          }
        };
        dataJSON.review = review;
      }
      // openHours
      var dayOfWeek = [];
      weekday.forEach(function (v) {
        return dayOfWeek.push(_Constant.DAY_OF_WEEK[v]);
      });
      if (dayOfWeek.length && openTime && closeTime) {
        // "openingHoursSpecification":

        var openingHoursSpecification = [{
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: dayOfWeek,
          opens: Helper.toTime(openTime),
          closes: Helper.toTime(closeTime)
        }];
        dataJSON.openingHoursSpecification = openingHoursSpecification;
      }
      return (0, _stringify2.default)(dataJSON);
    }
    return null;
  },
  provinceToOptions: function provinceToOptions(provinces) {
    var options = [];
    for (var index = 0; index < provinces.length; index++) {
      if (provinces[index].code === '01' || provinces[index].code === '79') {
        options = (0, _lodash.concat)([{
          value: provinces[index].code,
          label: provinces[index].code === '79' ? 'Tp.HCM' : provinces[index].name
        }], options);
      } else {
        options.push({
          value: provinces[index].code,
          label: provinces[index].name
        });
      }
    }
    return options;
  },
  districtToOptions: function districtToOptions(districts) {
    var options = [];
    for (var index = 0; index < districts.length; index++) {
      options.push({
        value: districts[index].code,
        label: districts[index].type + ' ' + districts[index].name
      });
    }
    return options;
  },
  parseSubcatFromVoucher: function parseSubcatFromVoucher(vouchers) {
    var result = [];
    if (vouchers) {
      vouchers.map(function (voucher) {
        var service = voucher.service || voucher.serviceRewrite;
        if (service && service.subcatInfo && service.subcatInfo.length) {
          result = [].concat((0, _toConsumableArray3.default)(result), (0, _toConsumableArray3.default)(service.subcatInfo));
        }
      });
      result = (0, _lodash.uniqBy)(result, 'code');
    }
    return result;
  }
};

function subCoupon(arr, obj) {
  var result = {};
  for (var i = 0, len = arr.length; i < len; i++) {
    var field = arr[i];
    result[field] = obj[field];
  }
  return result;
}

function promoPrice(coupon, service) {
  if (coupon) {
    switch (coupon.typePromotion) {
      case 'free':
        return 0;
      case 'newPrice':
        return coupon.newPrice;
      case 'percent':
        return coupon.percent * service.price / 100;
      case 'discount':
        return service.price - coupon.valueDiscount;
      default:
        break;
    }
  }
  return '';
}

function promoData(data) {
  if (data) {
    var type = data.typeVoucher || data.campaign.typeVoucher || '';
    var campaign = {};
    var shop = {};
    var service = {};
    var link = '';
    var image = '';
    var code = '';
    switch (type) {
      case 'general':
        shop = data.shop;
        service = data.service;
        link = '/uu-dai/' + data.handle;
        image = data.image;
        code = data.code;
        campaign = subCoupon(fieldCoupon, data.campaign);
        campaign.usersUsed = data.usersUsed;
        campaign.newPrice = data.displayValue;
        break;
      case 'partner':
        shop = data.packageService.shop;
        service = data.packageService.service;
        link = '/uu-dai-doi-tac';
        image = data.packageService.image;
        code = data.code;
        campaign = subCoupon(fieldCoupon, data.campaign);
        campaign.code = data.code;
        campaign.isUsed = data.isUsed;
        campaign.newPrice = data.packageService.displayValue;
        break;
      default:
        break;
    }
    shop.address = shop.addressDisplay ? shop.addressDisplay : shop.address;
    return { shop: shop, service: service, link: link, campaign: campaign, image: image, code: code };
  }
  return {};
}

function partnerData(data, packageService) {
  if (data && packageService) {
    var shop = packageService.shop;
    var service = packageService.service;
    var link = '/uu-dai/' + packageService.handle;
    var image = packageService.image;
    var campaign = subCoupon(fieldCoupon, data.campaign);
    campaign.isUsed = data.isUsed;
    campaign.code = data.code;
    campaign.newPrice = packageService.displayValue;
    shop.address = shop.addressDisplay ? shop.addressDisplay : shop.address;
    return { shop: shop, service: service, link: link, image: image, campaign: campaign };
  }
  return {};
}

// Standardized data

var syncData = exports.syncData = {
  subCat: {
    '01': [],
    '02': [],
    '03': [],
    '04': [],
    '05': [],
    '06': []
  },
  pathname: {},
  cats: function cats(data) {
    var cats = [];
    if (data && data.length > 0) {
      for (var index = 0; index < data.length; index++) {
        var cat = data[index];
        var item = { label: cat.label, value: cat.code };
        var _children = [];
        var children = cat.childrens || [];

        if (children.length > 0) {
          item.icPlus = true;
          for (var i = 0; i < children.length; i++) {
            var child = children[i];
            var cItem = { label: child.label, value: child.code };
            _children.push(cItem);
          }
        }
        cats.push(item);
        syncData.subCat[cat.code] = _children;
        syncData.pathname[cat.code] = '/' + cat.link;
      }
    }
    return { key: 'category', type: '', data: cats };
  },
  subs: function subs(cat) {
    var data = [];
    if (cat && syncData.subCat[cat] && syncData.subCat[cat].length) {
      data = syncData.subCat[cat];
    }
    return { key: 'subcategory', type: '', data: data };
  },
  dists: function dists(data) {
    var result = [];
    if (data && data.length) {
      for (var i = 0; i < data.length; i++) {
        var dist = data[i];
        var item = { label: dist.type + ' ' + dist.name, value: dist.code };
        result.push(item);
      }
    }
    return { key: 'district', type: '', data: result };
  },
  provs: function provs(data) {
    var result = [];
    if (data && data.length) {
      for (var i = 0; i < data.length; i++) {
        var prov = data[i];
        var item = { label: prov.name, value: prov.code };
        result.push(item);
      }
    }
    return { key: 'province', type: '', data: result };
  },
  getPathByCat: function getPathByCat(catCode) {
    if (!catCode || !syncData.pathname[catCode]) return '/kham-pha';
    return syncData.pathname[catCode];
  }
};
function getListActive(key, filter, filterActive) {
  var result = [];
  var arr = filter.filter(function (v) {
    return v.key === key;
  });
  if (arr && arr.length) {
    var data = arr[0].data;
    for (var i = 0, len = data.length; i < len; i++) {
      var d = data[i];
      if (filterActive[key].indexOf(d.value) !== -1) {
        result.push(d);
      }
    }
  }
  return result;
}

function parseParams(filterActive) {
  var array = [];
  var category = '';
  if (filterActive.category) {
    var cats = [].concat((0, _toConsumableArray3.default)(filterActive.category));
    if (filterActive.subcategory) {
      cats = [].concat((0, _toConsumableArray3.default)(cats), (0, _toConsumableArray3.default)(filterActive.subcategory));
    }
    category = cats.length ? 'category=' + cats.join(',') : '';
  }
  if (category) {
    array.push(category);
  }

  var _query = '';
  if (filterActive.query && filterActive.query.length && filterActive.query[0] !== '') {
    _query = 'text_search=' + Helper.convertTextSearch(filterActive.query[0]);
  }
  if (_query) {
    array.push(_query);
  }
  for (var key in filterActive) {
    if (filterActive.hasOwnProperty(key)) {
      if (key !== 'query' && key !== 'category' && key !== 'subcategory' && filterActive[key] && filterActive[key].length && filterActive[key][0] !== '') {
        array.push(key + '=' + filterActive[key].join(','));
      }
    }
  }
  return array.join('&');
}
var PARSE_URL = {
  subcategory: 'subs',
  district: 'district',
  province: 'province',
  sort: 'sort',
  query: 'query'
};
// province: 'province', sort: 'sort'; Province và sort hiện tại cho chạy ngầm ko để trên url
function parseQuery(filterActive) {
  var filter = {};
  for (var key in PARSE_URL) {
    if (PARSE_URL.hasOwnProperty(key)) {
      var param = PARSE_URL[key];
      if (filterActive[key] && filterActive[key].length && filterActive[key][0] !== '') {
        filter[param] = filterActive[key].join(',');
      }
    }
  }
  return filter;
}


//////////////////
// WEBPACK FOOTER
// ./src/helpers/support.js
// module id = 19
// module chunks = 0